export const VehicleCountries = [
  {
    name: 'Austria',
    code: 'AT',
    emoji: '🇦🇹',
    dial_code: '+43',
  },
  {
    name: 'Belgia',
    code: 'BE',
    emoji: '🇧🇪',
    dial_code: '+32',
  },
  {
    name: 'Bułgaria',
    code: 'BG',
    emoji: '🇧🇬',
    dial_code: '+359',
  },
  {
    name: 'Chorwacja',
    code: 'HR',
    emoji: '🇭🇷',
    dial_code: '+385',
  },
  {
    name: 'Cypr',
    code: 'CY',
    emoji: '🇨🇾',
    dial_code: '+357',
  },
  {
    name: 'Czechy',
    code: 'CZ',
    emoji: '🇨🇿',
    dial_code: '+420',
  },
  {
    name: 'Dania',
    code: 'DK',
    emoji: '🇩🇰',
    dial_code: '+45',
  },
  {
    name: 'Estonia',
    code: 'EE',
    emoji: '🇪🇪',
    dial_code: '+372',
  },
  {
    name: 'Finlandia',
    code: 'FI',
    emoji: '🇫🇮',
    dial_code: '+358',
  },
  {
    name: 'Francja',
    code: 'FR',
    emoji: '🇫🇷',
    dial_code: '+33',
  },
  {
    name: 'Grecja',
    code: 'GR',
    emoji: '🇬🇷',
    dial_code: '+30',
  },
  {
    name: 'Hiszpania',
    code: 'ES',
    emoji: '🇪🇸',
    dial_code: '+34',
  },
  {
    name: 'Holandia',
    code: 'NL',
    emoji: '🇳🇱',
    dial_code: '+31',
  },
  {
    name: 'Irlandia',
    code: 'IE',
    emoji: '🇮🇪',
    dial_code: '+353',
  },
  {
    name: 'Litwa',
    code: 'LT',
    emoji: '🇱🇹',
    dial_code: '+370',
  },
  {
    name: 'Luksemburg',
    code: 'LU',
    emoji: '🇱🇺',
    dial_code: '+352',
  },
  {
    name: 'Łotwa',
    code: 'LV',
    emoji: '🇱🇻',
    dial_code: '+371',
  },
  {
    name: 'Malta',
    code: 'MT',
    emoji: '🇲🇹',
    dial_code: '+356',
  },
  {
    name: 'Niemcy',
    code: 'DE',
    emoji: '🇩🇪',
    dial_code: '+49',
  },
  {
    name: 'Polska',
    code: 'PL',
    emoji: '🇵🇱',
    dial_code: '+48',
  },
  {
    name: 'Portugalia',
    code: 'PT',
    emoji: '🇵🇹',
    dial_code: '+351',
  },
  {
    name: 'Rumunia',
    code: 'RO',
    emoji: '🇷🇴',
    dial_code: '+40',
  },
  {
    name: 'Słowacja',
    code: 'SK',
    emoji: '��🇰',
    dial_code: '+421',
  },
  {
    name: 'Słowenia',
    code: 'SI',
    emoji: '🇸🇮',
    dial_code: '+386',
  },
  {
    name: 'Szwecja',
    code: 'SE',
    emoji: '🇸🇪',
    dial_code: '+46',
  },
  {
    name: 'Ukraina',
    code: 'UA',
    emoji: '🇺🇦',
    dial_code: '+380',
  },
  {
    name: 'Węgry',
    code: 'HU',
    emoji: '🇭🇺',
    dial_code: '+36',
  },
  {
    name: 'Wielka Brytania',
    code: 'GB',
    emoji: '🇬🇧',
    dial_code: '+44',
  },
  {
    name: 'Włochy',
    code: 'IT',
    emoji: '🇮🇹',
    dial_code: '+39',
  },
];

export const VehicleCountryCodes = VehicleCountries.map((country) => ({
  label: country.code,
  value: country.code,
})).sort((a, b) => a.label.localeCompare(b.label));
